import { CheckCircle } from 'lucide-react';

interface ChoiceCardProps {
  image: string;
  label: string;
  description?: string;
  selected: boolean;
  onClick: () => void;
}

export function ChoiceCard({ image, label, description, selected, onClick }: ChoiceCardProps) {
  return (
    <button className={`choice-card ${selected ? 'is-selected' : ''}`} type="button" onClick={onClick}>
      <img alt="" src={image} />
      {selected && <CheckCircle className="choice-check" fill="white" size={24} />}
      <span className="choice-label">
        {label}
        {description && <small>{description}</small>}
      </span>
    </button>
  );
}
